import clipboardActions from "../../../constants/clipboardActions";
import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

let menus = [];

//#!if readonly === true
menus = [clipboardActions.COPY, nativeCommsMessageTypes.OPEN_SEARCH];
//#!endif

export default menus;
